import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  ClockCounterClockwise,
  TrendUp,
} from "@phosphor-icons/react";
import PublicDemoNav from "@/components/PublicDemoNav";
import { trackUmamiEvent } from "@/lib/umamiAnalytics";

const USE_CASES = [
  {
    key: "sales",
    title: "Winning new business",
    description: "Discovery, follow-ups & deal progression",
    path: "/demo/sales?section=transcript",
    mobilePath: "/demo/sales",
    Icon: TrendUp,
    status: "Sales",
  },
  {
    key: "renewals",
    title: "Growing & retaining customers",
    description: "Renewals, risk & ongoing relationships",
    path: "/demo/renewals?section=transcript",
    mobilePath: "/demo/renewals",
    Icon: ClockCounterClockwise,
    status: "AM · CSM",
  },
];

export default function LiveDemoUseCasePage() {
  const [isMobileDemo, setIsMobileDemo] = useState(() => (
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 767px)").matches
      : false
  ));

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const query = window.matchMedia("(max-width: 767px)");
    const update = (event) => setIsMobileDemo(event.matches);
    setIsMobileDemo(query.matches);
    query.addEventListener?.("change", update);
    return () => query.removeEventListener?.("change", update);
  }, []);

  const selectUseCase = (key) => {
    if (typeof window !== "undefined") {
      window.sessionStorage.removeItem("callsect:live-demo-stage");
      window.sessionStorage.setItem("callsect:live-demo-use-case", key);
    }

    trackUmamiEvent(`demo_use_case_${key}_selected`, {
      source: "demo",
      section: "use-case-selector",
      use_case: key,
      page_path: "/demo",
    });
  };

  return (
    <div className="relationship-page public-demo-page public-demo-selector-page">
      <PublicDemoNav selectionMode />

      <main className="public-demo-selector public-demo-selector--responsive product-page-enter">
        <section className="public-demo-selector__section">
          <div className="public-demo-selector__inner">
            <div className="public-demo-selector__intro">
              <div className="landing-eyebrow justify-center text-xs font-semibold uppercase tracking-[0.28em] text-indigo-400">
                <span className="landing-eyebrow__lines" aria-hidden="true"><i /></span>
                <span>Choose your use case</span>
              </div>
              <h1>What kind of calls do you handle?</h1>
            </div>

            <div className="public-demo-selector__grid">
              {USE_CASES.map(({ key, title, description, path, mobilePath, Icon, status }) => (
                <Link
                  key={key}
                  to={isMobileDemo ? mobilePath : path}
                  onClick={() => selectUseCase(key)}
                  className="public-demo-use-case-card"
                  aria-label={`Open ${status} demo: ${title}`}
                >
                  <div className="public-demo-use-case-card__header">
                    <span>{status}</span>
                    <h2>{title}</h2>
                  </div>

                  <div className="public-demo-use-case-card__summary">
                    <span className="public-demo-use-case-card__icon" aria-hidden="true">
                      <Icon size={24} weight="duotone" />
                    </span>
                    <p>{description}</p>
                  </div>

                  <span className="public-demo-use-case-card__affordance" aria-hidden="true">
                    <ArrowRight size={22} weight="bold" />
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

    </div>
  );
}
